const HANDLE_CLASS = "draggable-dialog";
export {
  HANDLE_CLASS
};
